export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-quadtree/src/root.js
// module id = 2uN7
// module chunks = 0